import type { SubscriptionAddon } from '../types';

/** Both auto-billing products share a name; their product and price IDs differ. */
export default function isAutoBillingAddon(
    addon: Partial<Pick<SubscriptionAddon, 'name'>> | null | undefined,
): boolean {
    return addon?.name?.toLowerCase().includes('autobilling') ?? false;
}
